import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-menu-container" }


const __default__ = {
  name: 'AdminMenu',
  methods: {
    onMenuItemClick(event) {
      this.$emit('menuitem-click', event);
    },
    onKeyDown(event) {
      const nodeElement = event.target;
      if (event.code === 'Enter' || event.code === 'Space') {
        nodeElement.click();
        event.preventDefault();
      }
    },
  },
};

import AdminSubMenu from './AdminSubMenu';


export default /*#__PURE__*/Object.assign(__default__, {
  props: {
  model: Array,
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AdminSubMenu), {
      items: __props.model,
      class: "layout-menu",
      root: true,
      onMenuitemClick: _ctx.onMenuItemClick,
      onKeydown: _ctx.onKeyDown
    }, null, 8, ["items", "onMenuitemClick", "onKeydown"])
  ]))
}
}

})